function generate_date_slider(self,days)
{
    var days_of_week = ['sun','mon','tues','wed','thurs','fri','sat'];
    var months_of_year = ['January','February','March','April','May','June','July','August','September','October','November','December'];
    var loading=false;
    var $=jQuery;
    self=$(self);
    if(typeof days == 'undefined')
        days=300;

    days+=7-days%7;
    var currentElementDay;
    var d = new Date();
    var offset=d.getDay();
    d.setDate(d.getDate() - offset);
    var ele;
    var timeline=$('<div class="timeline-slider"></div>');//.hide();
    var event_display=$('<div class="events"></div>');
    var all_dates=[];
    for (var i=0; i < days; d=new Date(d.getTime()),d.setDate(d.getDate() + 1),i++)
    {
        ele=$('<div>'+days_of_week[d.getDay()]+'<br />'+d.getDate()+'</div>');
        ele.data('date',d);
        ele.data('i',i);
        all_dates.push({date:d,element:ele});
        timeline.append(ele);
        if(i==offset)
            currentElementDay=ele;
    }

    var month=$('<div class="month"><i class="fa fa-angle-left left"></i><span></span><i class="fa fa-angle-right right"></i></div>');
    function setMonth(date)
    {
        $('span',month).html(months_of_year[date.getMonth()]+' '+date.getFullYear());
        month.data('date',date);
    }
    $('.left,.right',month).click(function(){
        var testDate=new Date(month.data('date').getTime());
        testDate.setMonth(testDate.getMonth()+($(this).is('.left')?-1:1));
        var bestDate = all_dates.length;
        var bestDiff = -(new Date(0,0,0)).valueOf();
        var currDiff = 0;
        var i;

        for(i = 0; i < all_dates.length; ++i){
           currDiff = Math.abs(all_dates[i].date - testDate);
           if(currDiff < bestDiff){
               bestDate = i;
               bestDiff = currDiff;
           }   
        }
        all_dates[bestDate].element.click();
    });
    var check_apt=$('<a href="#" class="check-avail button">Check Availability</a>');
    $('div',timeline).click(function(){
        if(loading)
            return;
        loading=true;
        $('div.slick-slide',timeline).removeClass('active');
        $(this).closest('.slick-slide').addClass('active');
        setMonth($(this).data('date'));
        dailyEvents.loadDate(all_dates[$(this).data('i')],function(out){
            var current=$('<div class="current">'+out+'</div>').hide();
            var last=$('.current',event_display);
            event_display.append(current);
            last.slideUp(function(){
                last.remove();
            },false);
            current.slideDown(function(){
                loading=false;
            });
        });
        if(typeof wp_vars["apt_page_url"] != 'undefined')
            check_apt.attr('href',wp_vars["apt_page_url"]+'?apt_date='+$(this).data('date').toISOString().split('T')[0]);
        timeline.slick('slickGoTo',$(this).data('i'));
    });
    var holder=$('<div class="upcoming-events-slider"></div>');
    holder.append(month);
    holder.append(timeline);
    var grid_width=$('<div class="grid-width"></div>');
    holder.append(grid_width);
    if(typeof wp_vars["apt_page_url"] != 'undefined')
        holder.append(check_apt);
    grid_width.append(event_display);
    self.after(holder).remove();
    timeline.slick({
        slidesToShow: 7,
        slidesToScroll: 7,
        infinite:false,      
        prevArrow:'<div class="prev"><i class="fa fa-angle-left"></i></div>',
        nextArrow:'<div class="next"><i class="fa fa-angle-right"></i></div>',
        responsive: [
            {
              breakpoint: 590,
              settings: {
                slidesToShow: 5,
                slidesToScroll: 5
              }
            },
            {
              breakpoint: 430,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3
              }
            }
        ]
    }).on('breakpoint',function(){
        setTimeout(function(){
            timeline.slick('slickGoTo',$('.active',timeline).data('i'));
        },500);
        
    });
    currentElementDay.click();

    
}

var dailyEvents={
    loadDate:function(o,cb,shortened)
    {
        if(typeof o.data != 'undefined')
        {
            this.build(o.data,cb,shortened);
            return;
        }
        var $=jQuery;
        var self=this;
        $.get('?getEvents='+o.date.toISOString().split('T')[0],function(resp){
            if(typeof resp.ok == 'undefined')
            {
                o.data=[];
                self.build(o.data,cb,shortened);
                return;
            }
            if(!resp.ok)
            {
                o.data=[];
                self.build(o.data,cb,shortened);
                return;
            }
            o.data=resp.data;
            self.build(o.data,cb,shortened);
        });
    },
    build:function(data,cb,shortened)
    {
        var out='';
        for(var i in data)
        {
            out+='<div class="event">';
             if(typeof data[i]['event_image'] != 'undefined')
                out+=data[i]['event_image'];
             else if(typeof data[i]['designer_image'] != 'undefined')
                out+=data[i]['designer_image'];
            out+='<div class="info">';
                if(typeof data[i]['designer_name'] != 'undefined')
                    out+='<h3>'+data[i]['designer_name']+'</h3>';
                if(typeof data[i]['designer_type'] != 'undefined')
                    out+='<h4>'+data[i]['designer_type']+'</h4>';
                out+='<span class="line"><i class="fa fa-calendar" aria-hidden="true"></i><span>'+data[i]['event_date_display']+'</span></span>';
                if(typeof data[i]['designer_country'] != 'undefined')
                    out+='<span class="line"><i class="fa fa-flag" aria-hidden="true"></i><span>'+data[i]['designer_country']+'</span></span>';
                if(typeof data[i]['exclusive'] != 'undefined')
                    out+='<span class="line"><i class="k-icon" aria-hidden="true"></i><span>Kleinfeld Exclusive Designer</span></span>';
                if(!shortened && false)//disabled
                    out+='<span class="line"><i class="fa fa-pencil-square-o" aria-hidden="true"></i><span>Call 646-633-4300 to schedule an appointment on the day of your visit.</span></span>';
                if(typeof data[i]['notes'] != 'undefined')
                    out+='<span class="line"><i class="fa fa-pencil-square-o" aria-hidden="true"></i><span>'+data[i]['notes']+'</span></span>';
            out+='</div>';
            if(typeof data[i]['designer_url'] != 'undefined' && !shortened)
                out+='<a href="'+data[i]['designer_url']+'">Read the Full Bio <i class="fa fa-angle-right" aria-hidden="true"></i></a>';
            if(typeof data[i]['products'] != 'undefined' && data[i]['products'].length>0 && !shortened)
            {
                out+='<div class="grid-width"><div class="products">';
                    for(var j in data[i]['products'])
                    {
                         out+='<a class="prod" href="'+data[i]['products'][j]['url']+'">'+data[i]['products'][j]['image']+'</a>';
                    }                   
                out+='</div></div>';
                if(typeof data[i]['designer_products_url'] != 'undefined')
                    out+='<a href="'+data[i]['designer_products_url']+'">Browse The Collection <i class="fa fa-angle-right" aria-hidden="true"></i></a>';
            }
            out+='</div>';            
        }
        if(data.length==0)
            out='<h3>No events on this day</h3>';
        
        cb(out);
        
    }
};